import React from 'react';

const About = () => {
  return (
    <div className="about" id="about">
      <div className="about-info">
        <div className="about-content">
          <h1>We are LA 16</h1>
          <h4>Serving since 2010, we are as proud as thankful for all the support. Our team at LA 16 is committed to serving you the best you ever had. </h4>
          <h4>Your taste is our priority. A well-expertised team at our hand we serve the best food of the county and will continue to do so.</h4>
          <h4>A 3-time Award-winning place is waiting for you. We love giving a reason for happiness to our people. Come again soon.</h4>
        </div>
      </div>
    </div>
  );
}

export default About;
